import { useTranslations } from "next-intl"

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import type { MerchantProfile } from "@/lib/zenstack/models"

import StripeConnection from "./StripeConnection"

export function StripeSettings({
  isOpen,
  setIsOpen,
  merchantProfile,
}: {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  merchantProfile: MerchantProfile
}) {
  const t = useTranslations("merchant.stripe.settings")

  return (
    <div className="space-y-6">
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>{t("title")}</DialogTitle>
          </DialogHeader>

          <StripeConnection merchantProfile={merchantProfile} />
        </DialogContent>
      </Dialog>
    </div>
  )
}
